import {
	type LayoutNavComponentProps,
	SvgFromUrl,
	TrackingLink,
} from '@ds-mgnl/marketing';
import { classNames } from '@dsx/react';
import logoSvg from '../assets/images/dssi-logo.svg';
import styles from './DssiLogo.module.css';

export type DssiLogoProps = LayoutNavComponentProps;

export function DssiLogo({ transparent }: DssiLogoProps) {
	return (
		<TrackingLink href="/" clickType="header_link" trackingText="Top Nav Logo">
			<SvgFromUrl
				url={logoSvg}
				height={'37px'}
				className={classNames(styles['logo'], {
					[styles['transparent']]: transparent,
				})}
			/>
		</TrackingLink>
	);
}
